import React from 'react';
import {
  FDBox, FDContentContainer, FDStack, FDTextButton,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { SmallNumberStepper } from 'Packages/FacetDesign/Components/Experimental/SmallNumberStepper';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import { noop } from 'Helpers/PropTypes';
import { dataAttrs } from 'Helpers/Testing';


export const GoalStrategiesDetailsLayout = ({
  totalGoals,
  numGoalsCompleted,
  showGoalStepper,
  onBack,
  backLabel,
  showBackButton,
}) => {
  return (
    <FDContentContainer maxWidth={'lg'}>
      <FadeInBox key={numGoalsCompleted}>
        <FDStack direction={'column'} spacing={2} width={'100%'} {...dataAttrs('goal-detail-page')}>
          {showBackButton
            ? (
              <FDBox>
                <FDTextButton label={backLabel} onClick={onBack} icon={'chevronLeft'} {...dataAttrs('goal-details-back-button')} />
              </FDBox>
            )
            : null
          }
          <FDStack direction={'column'} spacing={2} alignItems={'center'}>
            <MetaControlField attr={'title'} />
            { showGoalStepper
              ? <SmallNumberStepper
                labelPrefix="Goal"
                numSteps={totalGoals}
                numCompleted={numGoalsCompleted}
              /> : null }
            <MetaControlField attr={'subTitle'} />
            <MetaControlField attr={'sections'} />
          </FDStack>
        </FDStack>
      </FadeInBox>
    </FDContentContainer>
  );
};

GoalStrategiesDetailsLayout.defaultProps = {
  totalGoals: 1,
  numGoalsCompleted: 1,
  showGoalStepper: false,
  onBack: noop,
  backLabel: 'Back',
  showBackButton: false,
};

GoalStrategiesDetailsLayout.propTypes = {
  showGoalStepper: PropTypes.bool,
  totalGoals: PropTypes.number,
  numGoalsCompleted: PropTypes.number,
  onBack: PropTypes.func,
  showBackButton: PropTypes.bool,
  backLabel: PropTypes.string,
};
